import { useEffect, useRef } from 'react';
import { selectDistributorGTM, updateCartGTM } from 'shared/gtm';
import { GtmCartEventParams, SelectDistributorGTMProps } from './interfaces';

export default function useGTM() {
	const isMounted = useRef(false);

	const dispatchSelectDistributorGTM = ({ distributorName, distributorPrice }: SelectDistributorGTMProps) => {
		if (!isMounted.current || !distributorName || distributorPrice == null) return;

		console.log('gtm-dispatched=', 'dispatchSelectDistributorGTM');

		selectDistributorGTM({ distributorName, distributorPrice });
	};

	const gtmCartEvent = (
		type: 'remove_from_cart' | 'add_to_cart',
		{ quantity, selectedDistributor, ...product }: GtmCartEventParams,
	) => {
		const value = selectedDistributor.finalPrice || 0;
		const unitDiscount = selectedDistributor.unitDiscount || 0;
		const affiliation = selectedDistributor.distributorName || '';

		const total = value * quantity;

		const { ean13, description, brandName, categoryName, businessUnitName, suggestionGroupName, industryName } =
			product;

		const products = [
			{
				ean13,
				description,
				price: value,
				quantity,
				brandName,
				categoryName,
				businessUnitName,
				discount: unitDiscount,
				affiliation,
				combo: false,
				suggestionGroupName,
				industryName,
			},
		];

		console.log('gtm-dispatched=', 'gtmCartEvent');

		updateCartGTM(type, total, products);
	};

	useEffect(() => {
		isMounted.current = true;

		return () => {
			isMounted.current = false;
		};
	}, [isMounted.current]);

	return {
		dispatchSelectDistributorGTM,
		gtmCartEvent,
	};
}
